import {
  FETCH_JOB_LOGS_REQUEST,
  FETCH_JOB_LOGS_SUCCESS,
  FETCH_JOB_LOGS_FAILURE,
  CLEAR_JOB_LOGS,
} from "../../common/actionTypes";

const initialState = {
  logs: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const jobLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JOB_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_JOB_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload.data,
        totalCount:action.payload.totalCount,
        loading: false,
      };

    case FETCH_JOB_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
     case CLEAR_JOB_LOGS:
      return { ...state, logs: [] }; 

    default:
      return state;
  }
};

export default jobLogsReducer;
